import { ReactNode } from "react";

import { getUserClaims } from "../../utils/auth";
import { hasModule, isV2User } from "../../utils/rbac";

import { ContactAdminPage } from "./ContactAdminPage";

interface RequireModuleProps {
  /** Module the user must be assigned to. */
  moduleId: string;
  /** Display label for the gate page. */
  moduleLabel?: string;
  children: ReactNode;
}

/**
 * Wraps children behind a v2 RBAC module check. v1 users (no `mkClaims.rbac`
 * on JWT) and SuperKudu always pass through. v2 users without the module
 * assignment see a Contact Admin gate instead of the children.
 *
 * Usage:
 *   <RequireModule moduleId="marketing_analyzer" moduleLabel="Marketing Analyzer">
 *     <Routes />
 *   </RequireModule>
 */
export function RequireModule({
  moduleId,
  moduleLabel,
  children,
}: RequireModuleProps) {
  const { rbac, superKudu } = getUserClaims();

  if (
    isV2User(rbac) &&
    !hasModule(rbac, moduleId, { superKudu: !!superKudu })
  ) {
    return <ContactAdminPage moduleLabel={moduleLabel} />;
  }

  return <>{children}</>;
}
